export const Scan2Percentiles = [99, 97.5, 95]

export const Scan2PercentilesOptions = Scan2Percentiles.map((val) => ({ label: val, value: val }));